<!-- Section button with preview images that links to the section page. -->
<template>
  <ImageTileButton
    :title="name"
    :subtitle="tileSubtitle"
    :images="previewImageUrls"
    :image-count="2"
    :to="routeLocation"
    @click="emit('click', $event)"/>
</template>

<script setup>
import useClosetSection from '@/composables/closetSection.js'
import ImageTileButton from '@/components/global/ImageTileButton.vue'

const props = defineProps({
  sectionId: {
    type: String,
    required: true
  }
})

const { name, tileSubtitle, previewImageUrls, routeLocation } = useClosetSection(() => props.sectionId, { loadOnMount: true })

const emit = defineEmits({
  click: (event) => event instanceof MouseEvent
})
</script>
